import { render, staticRenderFns } from "./MonographyPage.vue?vue&type=template&id=4ba50d60&scoped=true"
import script from "./MonographyPage.vue?vue&type=script&lang=js"
export * from "./MonographyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba50d60",
  null
  
)

export default component.exports